import React, { useState } from 'react';
import Modal from '../utils/Modal';

function Intro() {

  const [videoModalOpen, setVideoModalOpen] = useState(false);

  return (
    <section className="relative">

      {/* Video behind hero content */}
      <div className="absolute inset-0">
        <video src="../public/../Videos/bg7.mp4" type="video/mp4" muted autoPlay loop playsinline className="z-0 w-full h-full object-cover fixed">Your browser does not support the HTML5 video tag.</video>
      </div>

      <div className="relative max-w-8xl mx-auto px-4 sm:px-6">
        {/* Hero content */}
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          {/* Section header text */}
          <div className="text-center pb-12 md:pb-16 select-none">
              <h1 className="text-5.5xl text-blue-200 font-extrabold leading-tighter tracking-tighter mb-4" data-aos="zoom-y-out">
                Kiire ja kvaliteetne trükiteenus 
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">
                  {" "}24/7
                </span>
              </h1>
              <h2 className="max-w-3xl mx-auto" data-aos="zoom-y-out" data-aos-delay="550">
                <span className="text-3xl bg-clip-text text-transparent bg-gradient-to-r from-teal-400 to-blue-500">
                (tasuta kohaletoomisega Tallinna piires)
                </span>
              </h2>    
          </div>

          {/* Hero image */}
          <div>
            
            <div className="relative flex justify-center mb-8" data-aos="zoom-y-out" data-aos-delay="550">
              <div className="flex flex-col justify-center">
                <img className="mx-auto" src={require('../images/hero-image-01.jpg').default} width="768" height="432" alt="Hero" />
              </div>

              {/* View video button */}
              <button className="absolute top-full flex items-center transform -translate-y-1/2 bg-gray-400 rounded-full group shadow-lg" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setVideoModalOpen(true); }} aria-controls="modal">
                <div className="opacity-70 hover:opacity-100 transition duration-150 ease-in-out p-4">
                  <img className="inline-block" width="24" viewBox="0 0 512 512" alt="" src={require('../images/icons/play-circle.svg').default}/>
                  <span className="ml-3 text-black font-medium">Vaata videot (36 sek)</span>
                </div>
              </button>

            </div>
            
            
            
            {/* Video modal */}
            <Modal id="modal" ariaLabel="modal-headline" show={videoModalOpen} handleClose={() => setVideoModalOpen(false)}>
              <div className="relative pb-9/16">
                <iframe className="absolute w-full h-full" src="https://www.youtube.com/embed/251NVpZLYFM" title="Video" allowFullScreen></iframe>
              </div>
            </Modal>
            
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;